module.exports = __webpack_public_path__ + "sundawn.png?3cc1c788b51ad378a5c9b83deb2f7153";